import React, { ForwardedRef, forwardRef, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Loader } from "@/components/Icons";

type ButtonProps = {
  children: ReactNode;
  className?: string;
  isLoading?: boolean;
  onClick?: () => void;
};
const Button = forwardRef(
  (
    { children, className, isLoading = false, ...otherProps }: ButtonProps,
    ref: ForwardedRef<any>
  ) => {
    return (
      <button
        className={twMerge(
          "flex items-center justify-center bg-primary hover:bg-red-700 px-5 py-2 text-sm leading-5 rounded-full font-semibold text-white disabled:opacity-70 disabled:hover:bg-primary",
          className
        )}
        {...otherProps}
        disabled={isLoading}
        ref={ref}
      >
        {isLoading ? (
          <span className="flex items-center justify-center">
            <Loader width={20} height={20} />
          </span>
        ) : (
          children
        )}
      </button>
    );
  }
);

export default Button;
